<template>
  <div class="grid">
		<div class="col-12">
            <div class="card">
                <Toast/>
                <Message ref="message" severity="error" :closable="true" v-if="errors.length">{{errors}}</Message>

                <Fieldset legend="Add New" :toggleable="true" :collapsed="true" class="mb-3" v-if="permission.includes('create')">
                    <div class="p-fluid">
                        <div class="formgrid grid">
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="username">Username</label>
                                <InputText id="username" v-model="forms.username" required="true" autofocus :class="{ 'p-invalid': errorAdd.username }" />
                                <small class="p-invalid" style="color: red" v-if="errorAdd.username" >{{ errorAdd.username[0] }}</small >
                            </div>
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="name">Name</label>
                                <InputText id="name" v-model="forms.name" required="true" autofocus :class="{ 'p-invalid': errorAdd.name }" />
                                <small class="p-invalid" style="color: red" v-if="errorAdd.name" >{{ errorAdd.name[0] }}</small >
                            </div>
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="level_id">Level</label>
                                <Dropdown id="level_id" v-model="forms.level_id" :loading="loadingDropdownLevelAdd" :options="dataDropdownLevelAdd" :class="{ 'p-invalid': errorAdd.level_id }" optionLabel="level_name" placeholder="Choose Level" :filter="true" :showClear="true" @filter="searchDropdownLevel($event ,'add')" @change="changeMcu('add')"/>
                                <small class="p-invalid" style="color: red" v-if="errorAdd.level_id" >{{ errorAdd.level_id[0] }}</small>
                            </div>
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="phone">Phone</label>
                                <InputText id="phone" v-model="forms.phone" required="true" autofocus :class="{ 'p-invalid': errorAdd.phone }" />
                                <small class="p-invalid" style="color: red" v-if="errorAdd.phone" >{{ errorAdd.phone[0] }}</small >
                            </div>
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="email">Email</label>
                                <InputText id="email" type="email" v-model="forms.email" required="true" autofocus :class="{ 'p-invalid': errorAdd.email }" />
                                <small class="p-invalid" style="color: red" v-if="errorAdd.email" >{{ errorAdd.email[0] }}</small >
                            </div>
                            <div class="field col-12 md:col-6 lg:col-3" v-if="this.forms.level_id?.level_id != '3'">
                                <label for="dropdownMcu">SPV</label>
                                <Dropdown v-model="forms.mcu_id" :loading="loadingDropdownMcuAdd" :options="dataDropdownMcuAdd" :class="{ 'p-invalid': errorAdd.spv_id }" optionLabel="label" optionValue="mcu_id" placeholder="Choose SPV" :filter="true" :showClear="true" @filter="searchDropdownMcu($event, 'add')" />
                                <small class="p-invalid" style="color: red" v-if="errorAdd.spv_id" >{{ errorAdd.spv_id[0] }}</small>
                            </div>
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="dropdownTerritory">Territory</label>
                                <Dropdown v-model="forms.territory_id" :loading="loadingDropdownTerritoryAdd" :options="dataDropdownTerritoryAdd" :class="{ 'p-invalid': errorAdd.territory_id }" optionLabel="territory_label" optionValue="territory_id" placeholder="Choose Territory" :filter="true" :showClear="true" @filter="searchDropdownTerritory($event, 'add')" />
                                <small class="p-invalid" style="color: red" v-if="errorAdd.territory_id" >{{ errorAdd.territory_id[0] }}</small>
                            </div>
                        </div>
                    </div>
                    <Button :loading="loadingAddNew" label="Save" icon="pi pi-save" class="p-button-primary" @click="saveNew" />
                </Fieldset>

                <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3" v-if="permission.includes('read')">
                    <div class="p-fluid">
                        <div class="formgrid grid">
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="dropdownLevel">Level</label>
                                <Dropdown v-model="filters.level_id" :loading="loadingDropdownLevelFilter" :options="dataDropdownLevelFilter" optionLabel="level_name" optionValue="level_id" placeholder="Choose Level" :filter="true" :showClear="true" @filter="searchDropdownLevel($event, 'filter')"/>
                            </div>
                        </div>
                    </div>
                    <Button :loading="loading" label="Filter" icon="pi pi-search" class="p-button-warning mr-2 my-1" @click="getDataTable" />
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="userid" @sort="onSort($event)" :resizableColumns="true" columnResizeMode="fit" v-if="permission.includes('read')">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('xlsx')"  v-if="permission.includes('download')"/>
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('csv')"  v-if="permission.includes('download')"/>
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Search..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="#" :style="{width:'20px'}" >
                        <template #body="slotProps">
                        {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="username" header="Username">
                        <template #body="slotProps">
                            {{slotProps.data.username}}
                        </template>
                    </Column>
                    <Column field="name" header="Name">
                        <template #body="slotProps">
                            {{slotProps.data.name}}
                        </template>
                    </Column>
                    <Column field="level_name" header="Level">
                        <template #body="slotProps">
                            {{slotProps.data.level_name}}
                        </template>
                    </Column>
                    <Column field="territory_name" header="User Territory">
                        <template #body="slotProps">
                            {{slotProps.data.territory_name}}
                        </template>
                    </Column>
                    <Column field="spv_code" header="SPV Username">
                        <template #body="slotProps">
                            {{slotProps.data.spv_code}}
                        </template>
                    </Column>
                    <Column field="spv_name" header="SPV Name">
                        <template #body="slotProps">
                            {{slotProps.data.spv_name}}
                        </template>
                    </Column>
                    <Column field="mcu_phone" header="Phone">
                        <template #body="slotProps">
                            {{slotProps.data.mcu_phone}}
                        </template>
                    </Column>
                    <Column field="mcu_email" header="Email">
                        <template #body="slotProps">
                            {{slotProps.data.mcu_email}}
                        </template>
                    </Column>
                    <Column field="user_status" header="User Status">
                        <template #body="slotProps">
                            <Button icon="pi pi-check" class="p-button-rounded p-button-success" v-if="slotProps.data.user_status == 'y'"/>
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger" v-else/>
                        </template>
                    </Column>
					<Column header="Action" headerStyle="min-width:10rem;">
						<template #body="slotProps">
                            <span class="p-buttonset">
                                <Button label="Edit Personal Info" icon="pi pi-pencil" @click="editItem(slotProps.data)" v-if="permission.includes('update')"/>
                                <Button label="Edit Territory" icon="pi pi-external-link" @click="detailItem(slotProps.data.userid,'territory')" v-if="permission.includes('read')"/>
                            </span>
						</template>
					</Column>
                    <template #empty>
                        No data found.
                    </template>
                    <template #loading>
                        Loading data. Please wait.
                    </template>
                    <template #footer>
                        In total there are {{totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount" :rowsPerPageOptions="[10,20,30]" v-if="permission.includes('read')">
                    <template>
                        {{totalItemsCount}}
                    </template>
                </Paginator>

				<Dialog v-model:visible="editItemDialog" :style="{width: '450px'}" header="Data Detail" :modal="true" class="p-fluid">
					<div class="field">
						<label for="Username">Username</label>
                        <InputText id="username" v-model="item.username" required="true" autofocus :class="{ 'p-invalid': errorEdit.username }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.username" >{{ errorEdit.username[0] }}</small >
					</div>
					<div class="field">
						<label for="name">Name</label>
                        <InputText id="name" v-model="item.name" required="true" autofocus :class="{ 'p-invalid': errorEdit.name }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.name" >{{ errorEdit.name[0] }}</small >
					</div>
					<div class="field">
                        <label for="level_id">Level</label>
                        <Dropdown id="level_id" ref="dlvl" v-model="item.level_id" :loading="loadingDropdownLevelEdit" :options="dataDropdownLevelEdit" :class="{ 'p-invalid': errorEdit.level_id }" optionLabel="level_name" optionValue="level_id" placeholder="Choose Level" :filter="true" :showClear="true" @filter="searchDropdownLevel($event,'edit')" @change="changeMcu('edit')"/>
                        <small class="p-invalid" style="color: red" v-if="errorEdit.level_id" >{{ errorEdit.level_id[0] }}</small>
					</div>
					<div class="field">
						<label for="phone">Phone</label>
                        <InputText id="phone" v-model="item.mcu_phone" required="true" autofocus :class="{ 'p-invalid': errorEdit.phone }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.phone" >{{ errorEdit.phone[0] }}</small >
					</div>
					<div class="field">
						<label for="email">Email</label>
                        <InputText id="email" v-model="item.mcu_email" required="true" autofocus :class="{ 'p-invalid': errorEdit.email }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.email" >{{ errorEdit.email[0] }}</small >
					</div>
                    <div class="field" v-if="item.level_id != '3'">
                        <label for="dropdownEditMcu">SPV</label>
                        <Dropdown ref="dmcu" v-model="item.spv_id" :loading="loadingDropdownMcuEdit" :options="dataDropdownMcuEdit" :class="{ 'p-invalid': errorEdit.spv_id }" optionLabel="label" optionValue="mcu_id" placeholder="Choose SPV" :filter="true" :showClear="true" @filter="searchDropdownMcu($event, 'edit')"/>
                        <small class="p-invalid" style="color: red" v-if="errorEdit.spv_id" >{{ errorEdit.spv_id[0] }}</small >
                    </div>
                    <div class="field">
                        <label>User Status</label>
                        <Dropdown v-model="item.user_status" :options="dataDropdownStatus" optionLabel="name" optionValue="code" placeholder="Select Status" :class="{ 'p-invalid': errorEdit.user_status }"/>
                            <small class="p-invalid" style="color: red" v-if="errorEdit.user_status" >{{ errorEdit.user_status[0] }}</small>
                    </div>
					<template #footer>
						<Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
						<Button label="Save" icon="pi pi-check" class="p-button-text" @click="updateItem" :loading="loadingEdit"/>
					</template>
				</Dialog>
            </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import { numberingDatatable } from '../../utils/helpers';

export default {
    data() {
        return {
            // loading
            loading: false,
            loadingAddNew: false,
            loadingEdit: false,
            loadingDropdownLevelAdd: false,
            loadingDropdownLevelEdit: false,
            loadingDropdownLevelFilter: false,
            loadingDropdownMcuAdd: false,
            loadingDropdownMcuEdit: false,
            loadingDropdownTerritoryAdd: false,
            loadingDropdownTerritoryEdit: false,
            loadingExcel: false,
            loadingCsv: false,

            // dataDropdown
            dataDropdownLevelAdd: null,
            dataDropdownLevelEdit: null,
            dataDropdownLevelFilter: null,
            dataDropdownMcuAdd: null,
            dataDropdownMcuEdit: null,
            dataDropdownTerritoryAdd: null,
            dataDropdownTerritoryEdit: null,
            dataDropdownStatus: [
                {name: 'ACTIVE', code: 'y'},
                {name: 'NON ACTIVE', code: 'n'},
            ],

            // addNew
            forms: {
                username: null,
                name: null,
                phone: null,
                email: null,
                level_id: null,
                mcu_id: null,
                territory_id: null
            },

            // edit
            item: {},
            editItemDialog: false,
            
            // filter
            filters: {
                level_id: null,
            },

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        }
    },
    mounted() {
        this.getDataTable();
        this.$store.commit('setErrors', {});
        this.$store.commit('setErrorAdd', {});
        this.$store.commit('setErrorEdit', {});
        this.searchDropdownLevel('');
        this.searchDropdownTerritory('');
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed:{
        ...mapGetters(['errors', 'errorEdit', 'errorAdd']),

		...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value){
            if (value) {
                return moment.utc(value).format('DD-MM-YYYY')
            }
        },
        // DROPDOWN
        searchDropdownLevel(event, purpose, valueEdit){
            setTimeout(() => {

                if(valueEdit){
                    this.$refs.dlvl.filterValue = valueEdit;
                }

                if(purpose == "filter"){
                    this.loadingDropdownLevelFilter = true;
                }else if(purpose == "add"){
                    this.loadingDropdownLevelAdd = true;
                }else if(purpose == "edit"){
                    this.loadingDropdownLevelEdit = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/level-user',
                    params: {
                        "search" : valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if(purpose == "filter"){
                        this.dataDropdownLevelFilter = res.data.data;
                        this.loadingDropdownLevelFilter = false;
                    }else if(purpose == "add"){
                        this.dataDropdownLevelAdd = res.data.data;
                        this.loadingDropdownLevelAdd = false;
                    }else if(purpose == "edit"){
                        this.dataDropdownLevelEdit = res.data.data;
                        this.loadingDropdownLevelEdit = false;
                    }else if(purpose == null){
                        this.dataDropdownLevelFilter = res.data.data;
                        this.dataDropdownLevelAdd = res.data.data;
                        this.dataDropdownLevelEdit = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        changeMcu(purpose){
            if(purpose == 'add'){
                this.forms.mcu_id= null;
                this.dataDropdownMcuAdd= null;

                if(this.forms.level_id){
                    this.searchDropdownMcu('','add');
                }
            }else if(purpose == 'edit'){
                this.item.spv_id= null;
                this.dataDropdownMcuEdit= null;
                // this.$refs.dmcu.filterValue = null;

                if(this.item.level_id){
                    this.searchDropdownMcu('','edit');
                }
            }
        },
        searchDropdownMcu(event, purpose, valueEdit){
            setTimeout(() => {

                var level_id = null;

                if(valueEdit){
                    this.$refs.dmcu.filterValue = valueEdit;
                }

                if(purpose == "add"){
                    this.loadingDropdownMcuAdd = true;
                    level_id = this.forms.level_id.level_name;
                }else if(purpose == "edit"){
                    this.loadingDropdownMcuEdit = true;
                    var level = null
                    if(this.item.level_id == '1'){
                        level = 'SR'
                    } else if(this.item.level_id == '2'){
                        level = 'CDE'
                    } else if(this.item.level_id == '3'){
                        level = 'ACDM'
                    } else if(this.item.level_id == '4'){
                        level = 'DVSP'
                    } else if(this.item.level_id == '5'){
                        level = 'MD'
                    }
                    level_id = level;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/spv',
                    params: {
                        "search" : valueEdit ? valueEdit : event.value,
                        "level" : level_id
                    }
                })
                .then(res => {

                    if(purpose == "add"){
                        this.dataDropdownMcuAdd = res.data.data;
                        this.loadingDropdownMcuAdd = false;
                    }else if(purpose == "edit"){
                        this.dataDropdownMcuEdit = res.data.data;
                        this.loadingDropdownMcuEdit = false;
                    }else if(purpose == null){
                        this.dataDropdownMcuAdd = res.data.data;
                        this.dataDropdownMcuEdit = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        searchDropdownTerritory(event, purpose, valueEdit){
            setTimeout(() => {

                if(valueEdit){
                    this.$refs.dterritory.filterValue = valueEdit;
                }

                if(purpose == "add"){
                    this.loadingDropdownTerritoryAdd = true;
                }else if(purpose == "edit"){
                    this.loadingDropdownTerritoryEdit = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/master-territory',
                    params: {
                        "search" : valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if(purpose == "add"){
                        this.dataDropdownTerritoryAdd = res.data.data;
                        this.loadingDropdownTerritoryAdd = false;
                    }else if(purpose == "edit"){
                        this.dataDropdownTerritoryEdit = res.data.data;
                        this.loadingDropdownTerritoryEdit = false;
                    }else if(purpose == null){
                        this.dataDropdownTerritoryAdd = res.data.data;
                        this.dataDropdownTerritoryEdit = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        // ADDNEW
        saveNew() {
            this.loadingAddNew = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userhp/create',
                data: {
                    "username": this.forms.username,
                    "level_id": this.forms.level_id.level_id,
                    "spv_id": this.forms.mcu_id,
                    "name": this.forms.name,
                    "phone": this.forms.phone,
                    "email": this.forms.email,
                    "territory_id": this.forms.territory_id
                },
            })
            .then((res) => {
                this.loadingAddNew = false;
                if (res) {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Saved', life: 3000,});
                    this.$store.commit('setErrors', {});
                    this.$store.commit('setErrorAdd', {});
                    this.clearForms();
                    this.getDataTable();
                }
            })
            .catch((err) => {
                console.log(err);
                this.loadingAddNew = false;
                this.$store.commit('setErrorAdd', err.response.data.data);
                this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Save', life: 3000,});
            });
        },
        clearForms() {
            this.forms.username = null;
            this.forms.level_id = null;
            this.forms.mcu_id= null;
            this.forms.name= null;
            this.forms.phone= null;
            this.forms.email= null;
            this.forms.territory_id= null;
        },
        // EDIT
		editItem(item) {
			this.item = item;
            
            // dropdown 
            this.searchDropdownLevel('', 'edit', item.level_name);
            this.searchDropdownMcu('', 'edit', item.spv_id ? item.spv_code +'-'+item.spv_name : null);

			this.editItemDialog = true;
            this.$store.commit('setErrorEdit', {});

		},
		hideDialog() {
			this.editItemDialog = false;
			this.submitted = false;
		},
		updateItem() {
            this.loadingEdit = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userhp/update',
                data: {
                    "userid" : this.item.userid,
                    "username" : this.item.username,
                    "level_id" : this.item.level_id,
                    "spv_id" : this.item.spv_id,
                    "name" : this.item.name,
                    "phone" : this.item.mcu_phone,
                    "email" : this.item.mcu_email,
                    "status" : this.item.user_status
                },
            })
            .then((res) => {
                this.loadingEdit = false;
                if (res) {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Updated', life: 3000,});
                    this.$store.commit('setErrors', {});
                    this.$store.commit('setErrorEdit', {});
                    this.item = {};
                    this.editItemDialog = false;
                    this.getDataTable();
                }
            })
            .catch((err) => {
                console.log(err);
                this.loadingEdit = false;
                this.$store.commit('setErrorEdit', err.response.data.data);
                this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Updated', life: 3000,});
            });
		},
        // DATATABLE
        getDataTable(){
          
            this.loading=true;
            this.page = (this.offset / this.rows) + 1;

            this.axios({
                method: 'GET',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userhp',
                params: {
                    "search" : this.search,
                    "per_page" : this.rows,
                    "page" : this.page,
                    "order_by" : this.field,
                    "sort_by" : this.sort,
                    "level_id" : this.filters.level_id,
                }
            })
            .then(res => {
              this.data = res.data.data.data;
              this.dataTable = numberingDatatable(res.data.data.data, this.page, this.rows);
              this.totalItemsCount = res.data.data.total;
              this.rows = parseInt(res.data.data.per_page);
              this.loading=false;
            })
            .catch((err) => {
                console.log(err);
            });
         
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == '1' ? 'ASC' : 'DESC';
            this.getDataTable();
        },
        // DETAIL
		detailItem(id, to) {
            if(to == 'territory'){
                this.$router.replace({ name: "hp-users-territory", params: {id:id} })
            }else{
                alert('sorry page doesnt exist');
            }
		},
        // EXPORT
        exportExcelCSV(ext){

            if(ext == 'xlsx'){
                this.loadingExcel=true;
            }else if(ext == 'csv'){
                this.loadingCsv=true;
            }

            this.axios({
            method: 'GET',
            url: process.env.VUE_APP_ROOT_API + 'web/master-userhp/export',
            responseType: 'blob',
            params: {
                "ext" : ext,
                "level_id" : this.filters.level_id,
            }
            })
            .then(response => {
                let fileUrl = window.URL.createObjectURL(response.data);
                let fileLink = document.createElement('a');

                fileLink.href = fileUrl;

                fileLink.setAttribute('download', 'Hp Users Export.' + ext);
                
                document.body.appendChild(fileLink)

                fileLink.click();
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }

            })
            .catch((err) => {
                console.log(err);
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }
            });
        },
    }
}
</script>